import { useEffect } from 'react';

export function useDocumentTitle(...titleParts) {
  useEffect(() => {
    document.title = titleParts.join(' › ');
  }, [titleParts]);
}
